import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Dialog } from "@mui/material";
import SweetAlert2 from "react-sweetalert2";
import * as actions from "../../redux/SettingAction";
import { useIntl } from "react-intl";
import { CopyToClipboard } from "../../../../utils/CommonHelper";
import { useAuth } from "../../../auth/components/AuthInit";

export const LiveChat = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [swalProps, setSwalProps] = useState({});
  const [open, setOpen] = useState(false);
  const [chatLink, setChatLink] = useState("");
  const { auth } = useAuth();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);
  const handleClose = () => {
    setOpen(false);
  };

  const handlNew = () => {
    window.open(chatLink);
    setOpen(false);
  };

  useEffect(() => {
    const queryParams = {
      ipaddress: "",
      currencycode: auth.currencycode,
    };
    dispatch(actions.getLiveChat(queryParams));
  }, []);

  const handleContactClick = (urllink, contacttype) => {
    const constructCustomerServiceLink = () =>
      contacttype === "Whatsapp"
        ? `${urllink}?text=Hi%20279RC%20Customer%20Service%20${auth.username}`
        : urllink;

    const customerServiceLink = constructCustomerServiceLink();
    setChatLink(customerServiceLink);

    if (sessionStorage.getItem("platform") === "mobile") {
      console.log(`customerservice: ${customerServiceLink}`);
      sessionStorage.setItem("customerServiceLink", customerServiceLink);
    } else {
      const isSafari = /^((?!chrome|android).)*safari/i.test(
        navigator.userAgent
      );
      if (isSafari || sessionStorage.getItem("platform") === "telegram") {
        setOpen(true);
      } else {
        window.open(customerServiceLink);
      }
    }
  };

  return (
    <div
      style={{
        backgroundColor: "black",
        backgroundImage: `url(${process.env.PUBLIC_URL}/image/homebackground.avif)`,
        backgroundSize: "cover",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <SweetAlert2
        onResolve={() => {
          setSwalProps({});
        }}
        backdrop={false}
        {...swalProps}
        customClass="custom-swal"
      />
      <div style={styles.navBar}>
        <div className="text-font4" style={styles.title}>
          {intl.formatMessage({ id: "liveChat" })}
        </div>
      </div>
      {settingState &&
        settingState.liveChat &&
        settingState.liveChat.contactLists.map((contact, index) => (
          <div className="m-2 ">
            <div
              className="d-flex align-items-center"
              style={{
                background: "#1c1e23",
                border: "1px solid white",
                borderRadius: "5px",
                color: "white",
              }}
              key={index}
            >
              <div className="mx-1 my-2">
                <img
                  src={contact.iconurl}
                  alt="Icon"
                  style={{ width: "3rem", height: "3rem" }}
                />
              </div>
              <div className="d-flex flex-column">
                <div
                  style={{
                    color: "#0080FF",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    handleContactClick(contact.directurl, contact.contacttype)
                  }
                >
                  {contact.directurl}
                </div>
                <div>
                  {contact.telno}{" "}
                  <i
                    className="bi bi-copy"
                    onClick={() => {
                      if (sessionStorage.getItem("platform") === "mobile") {
                        console.log(`clipboard: ${contact.telno}`);
                        CopyToClipboard(`${contact.telno}`, setSwalProps, intl);
                      } else {
                        CopyToClipboard(`${contact.telno}`, setSwalProps, intl);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      <Dialog open={open} onClose={handleClose}>
        <div
          className="text-font3"
          style={{
            padding: "20px",
            backgroundColor: "#1c1e23",
            color: "white",
          }}
        >
          <p> {intl.formatMessage({ id: "openCustomerService" })}</p>
          <div
            style={{ color: "#f5be09", textAlign: "end" }}
            onClick={handlNew}
          >
            {intl.formatMessage({ id: "confirm" })}
          </div>
        </div>
      </Dialog>
    </div>
  );
};
const styles = {
  navBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    backgroundColor: "black",
  },
  backButton: {
    position: "absolute",
    left: "10px",
    fontSize: "20px",
  },
  title: {
    fontWeight: "bold",
    color: "white",
  },
};
